exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=\"file\"] {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1; }\n\ninput[type=\"file\"] + label {\n  cursor: pointer;\n  -ms-flex-pack: start;\n      justify-content: flex-start; }\n\ninput[type=\"file\"]:focus + label {\n  outline: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/file-input/file-input.component.scss
// module id = ../../../../../src/app/ui-shared/file-input/file-input.component.scss
// module chunks = main